import React from 'react'

import Sidebar from "../sidebar/sidebar.js"; 
import { Footer } from '../../../common/footer/footer';
import AccountSetting from "../accountSetting/accountSetting.js"
import ManageUser from "../../dashboardCommon/manageUser/manageUser.js"
import ChangePassword from "../../../common/changePassword/changePassword.js"
import MyPlansJsxclass from '../../dashboardCommon/myPlane/myPlane';
import accountsettingdashboard from "../../../../assets/images/accountsettingdashboard.svg";
import '../myAccount/myAccount.model.css';
import { Trans, useTranslation } from 'react-i18next';

import accountSetting from "../../../../assets/images/accountsettingdashboard.svg";
import changePassword from "../../../../assets/images/Change_password.svg";
import manageUser from "../../../../assets/images/asktheexpertdashboard.svg";
import myPlans from "../../../../assets/images/mypaymentdashboard.svg";


const MyAccountsJsx = (props) => {


  const {
    activeTab,
    onTabClick
  } = props;


  const data = JSON.parse(localStorage.getItem("auth"))
  const { t } = useTranslation();

  // {t("PRINT.TITLE")}
  return (
    <>
       <section className="main_institute_dashboard">
        <section className="entiredashboard maincustomerdash main institute_dashboard">
        <div className="container-fluid">
          <div className="row dashboard-decoration">
            <div className="col-lg-4 col-sm-4">
              <Sidebar />
            </div>
            <div className="col-lg-8 col-sm-8 dashboard-data">
              <div className="dashboardrightpannerinnerleft dashboardrightpanel">
              <h2 className="h2_style font-weight-600 d-block d-lg-none d-sm-none d-md-none"><span className="headingicon d-block d-lg-none d-sm-none d-md-none "><img alt="article" src={accountsettingdashboard} /></span>{t("instituteAccount.HEADING")}</h2>
              <div className="row" >
                <div className="col-12">
                  <p className="dahsboardTitle d-none d-sm-block">{t("instituteAccount.HEADING")}</p>
                  <p className="subTitle psleft5"><Trans i18nKey={`instituteAccount.SUBHEADING`}></Trans></p>
                  
                </div>
                {/* <div className="col-1  d-none d-sm-block"  >
                  <div className="helpbutton">
                    <img className="helpImg" src={help} alt={'icon'} />
                    <p className="logout ">{t("instituteAccount.HELP")} </p>
                  </div>
                </div> */}
               
              </div>
              <div className=" ">
                <section classname=" ">
                  <div className="myaccountnav">
                    <ul>          
                       <li class={`${activeTab === 'acntStng' ? 'active' : ''}`} onClick={() => onTabClick('acntStng')}><img class={`${activeTab === 'acntStng' ? 'active' : ''}`} src={accountSetting} alt={'icon'} />Account Settings</li>
                      {data.loggedInAs==='institute' && <li class={`${activeTab === 'mngUser' ? 'active' : ''}`} onClick={() => onTabClick('mngUser')}><img class={`${activeTab === 'mngUser' ? 'active' : ''}`} src={manageUser} alt={'icon'} />Manage Users</li>}
                  <li class={`${activeTab === 'myPlans' ? 'active' : ''}`} onClick={() => onTabClick('myPlans')}><img class={`${activeTab === 'myPlans' ? 'active' : ''}`} src={myPlans} alt={'icon'} />My Plans</li>
                  <li class={`${activeTab === 'newPass' ? 'active' : ''}`} onClick={() => onTabClick('newPass')}><img class={`${activeTab === 'newPass' ? 'active' : ''}`} src={changePassword} alt={'icon'} />Change Password</li>

                    </ul>
                  </div>
                  {
                    activeTab === 'acntStng' ? <AccountSetting /> : activeTab === 'mngUser' ? <ManageUser /> : activeTab === 'newPass' ? <div className="accountchangepass"><h2 className="textchange">Password Creation</h2><ChangePassword /></div> : <MyPlansJsxclass />
                  }
                </section>
              </div>
            </div>
            </div>
          </div>
        </div>
      </section>
      <Footer/>
      </section>
    </>

  );
};

export default MyAccountsJsx;
